import React from "react";
import {PrimaryCollapsibleSection} from "../../../../../elements/collapsableSection/primary/PrimaryCollapsibleSection";
import {CardField} from "./components/CardField";
import {FollowUpCard} from "../../../../../elements/followUpCard/FollowUpCard";
import {formatDateTime} from "../../../../../../utils/dateTimeUtil";
import {EventType, SupportedTimezone} from "../../../../../../api/generated";
import {StatusBadge} from "../../../../../elements/statusBadge/StatusBadge";

interface FollowUpChatEventCardProps {
    eventType: EventType
    eventDateTime?: string
    preferredDateTime?: string
    timezone?: SupportedTimezone
    vrm?: string
    vehicleReference?: string
    rawVehicleDetails?: string
    isCancelled?: boolean
}

export const FollowUpChatEventCard: React.FC<FollowUpChatEventCardProps> = ({
                                                                                eventType,
                                                                                eventDateTime,
                                                                                preferredDateTime,
                                                                                timezone,
                                                                                vrm,
                                                                                vehicleReference,
                                                                                rawVehicleDetails,
                                                                                isCancelled
                                                                            }) => {
    const getLegacyEventStatus = () => {
        if (isCancelled) {
            return "cancelled";
        }

        if (eventDateTime) {
            const eventDate = new Date(eventDateTime);
            const now = new Date();

            if (eventDate > now) {
                return "upcoming";
            } else {
                return "past";
            }
        }
    };

    const getTitle = () => {
        switch (eventType) {
            case EventType.RequestedServiceCallback:
                return "Service Callback Request";
            case EventType.RequestedCallback:
                return "Callback Request";
            case EventType.RequestedTestDrive:
                return "Test Drive Request";
            case EventType.RequestedEmailFollowUp:
                return "Email Follow-up Request";
            case EventType.BookedCallBack:
                return "Callback";
            case EventType.BookedTestDrive:
                return "Test Drive";
            case EventType.BookedEmailFollowUp:
                return "Email Follow-up";
            default:
                return "Follow-up";
        }
    };

    const status = getLegacyEventStatus();
    const title = getTitle();
    const vehicleDetails = [vehicleReference, vrm].filter(Boolean).join(" / ");

    return <PrimaryCollapsibleSection title={title}>
        <CardField
            title={"Type"}
            valueComponent={FollowUpCard}
            props={{eventType: eventType}}
        />
        {status &&
            <CardField
                title="Status"
                valueComponent={StatusBadge}
                props={{status}}
            />
        }
        {eventDateTime && (() => {
            const {date, time} = formatDateTime(eventDateTime, timezone);
            return <CardField
                title="Date/Time"
                value={`${date} at ${time} (${timezone})`}
            />
        })()}
        {preferredDateTime && <CardField
            title="Preferred Date/Time"
            value={preferredDateTime}
        />}
        {vehicleDetails && <CardField
            title="Vehicle Details"
            value={vehicleDetails}
        />
        }
        {!vehicleDetails && rawVehicleDetails && <CardField
            title="Vehicle Details"
            value={rawVehicleDetails}
        />
        }
    </PrimaryCollapsibleSection>
}
